import { useGetUserInfo } from "../hook.auth/get-user-info";

interface UseIsLoggedInGuestReturn {
  isFetched: boolean;
  isLoggedInGuest?: boolean | null;
}
const useIsLoggedInGuest = (): UseIsLoggedInGuestReturn => {
  const { data: userData, isFetched } = useGetUserInfo();

  let isLoggedInGuest = null;
  if (userData?.email) {
    isLoggedInGuest = /@guest\.panich$/.test(userData.email);
  }

  return {
    isFetched,
    isLoggedInGuest,
  };
};

export { useIsLoggedInGuest };
